/* global API */
// @ts-nocheck

import generalSlider from './slider';
import videoElement from './videoElement';

const $modal = $('.js-service-modal');
const $content = $('.js-service-modal-content');
const $toggler = $('.js-service-modal-toggler');

const serviceModal = {
  initialize() {
    if ($modal.length) {
      this.createListeners();
    }
  },

  createListeners() {
    $toggler.on('click', (e) => this.onTogglerClick(e))

    $modal.on('shown.bs.modal', () => {
      this.setSlickPosition();
      this.setVideos();
    });

    $modal.on('hidden.bs.modal', () => $content.html(''));
  },

  onTogglerClick({ currentTarget }) {
    const { serviceId, serviceSiteId } = currentTarget.dataset;

    this.fetchService(serviceId, serviceSiteId)
      .then((res) => this.addDataToModal(res.data))
      .then(this.setSlickPosition())
      .then(this.openModal)
      .then(this.setVideos());
  },

  addDataToModal(data) {
    $content.html(data);
  },

  openModal() {
    $modal.modal('show');
  },

  fetchService(serviceId, serviceSiteId) {
    if (!serviceId) return Promise.reject(new Error('Service ID not given'));

    return $.ajax({
      method: 'POST',
      url: API.service,
      dataType: 'json',
      data: {
        service_id: serviceId,
        site_id: serviceSiteId || null,
      },
    })
  },

  setSlickPosition() {
    generalSlider.initialize();
  },

  setVideos() {
    videoElement.initialize();
  }
};

export default serviceModal;
